import Link from "next/link";
import { Form, Col, Button, InputGroup, FormControl } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { authServices } from "@/services/authServices";
import styles from "@/styles/ForgotPassoword.module.css";

function ForgotPasswordCard(props) {
  const { pageStateHandler, userType } = props;
  // Yup schema to validate the form
  const validationSchema = Yup.object().shape({
    email: Yup.string().required().email(),
  });

  // Formik hook to handle the form state
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    // Pass the Yup schema to validate the form
    validationSchema,
    // Handle form submission
    onSubmit: async ({ email }) => {
      const res = await authServices.forgotPassword({ email });
      if (res.status) {
        toast.success(res.message, {
          autoClose: 5000,
        });
      } else {
        toast.error(res.message, {
          autoClose: 5000,
        });
      }
    },
  });

  const { errors, touched, values, handleChange, handleSubmit } = formik;

  return (
    <Col sm={7} className="align-self-center">
      <div className={styles["login-customer-card"]}>
        <div className={styles["card-header"]}>
          <h4>
            Forgot Password Your{" "}
            {userType == "customer" ? "Customer" : "Healer"} Account
          </h4>
          <p>
            Enter your Email to recover your password. You will receive an email
            with instructions.
          </p>
        </div>
        <div className={styles["form-customer"]}>
          <Form onSubmit={handleSubmit}>
            <InputGroup className="mb-3">
              <InputGroup.Text  className={styles["input-group-text"]}>
                <i className="ri-mail-line"></i>
              </InputGroup.Text>
              <FormControl
                className={styles["form-control"]}
                id="email"
                name="email"
                type="email"
                onChange={handleChange}
                value={values.email}
                placeholder="Email"
              />
              <InputGroup>
              <span className="w-100">
                {touched.email && errors.email ? (
                  <div className="text-danger h6">{errors.email}</div>
                ) : null}
                </span>
              </InputGroup>
            </InputGroup>
            <Button type="submit" className={styles["theme-btn"]+ " " + 'px-5'}>
              Forgot Password
            </Button>
          </Form>
        </div>
        <div className={styles["card-footer"]}>
          <p>
            Don&amp;t have any account?{" "}
            <Link
              href={`/auth/${userType}/social/signup`}
              shallow={true}
              onClick={() => pageStateHandler("socialSignIn")}
            >
              Sign-up
            </Link>
          </p>
        </div>
      </div>
    </Col>
  );
}

export default ForgotPasswordCard;
